var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  fc.backgrounds =[
    { name: 'moscow.jpg', url: 'moscow.jpg'},
    { name: 'paris2.jpg', url: 'paris2.jpg'},
    { name: 'NYE_Sydney.jpg', url: 'NYE_Sydney.jpg'},
    { name: 'NYE_NY.jpg', url: 'NYE_NY.jpg'},
    { name: 'NYE_London.jpg', url: 'NYE_London.jpg'},
    { name: 'NYE_SF.jpg', url: 'NYE_SF.jpg'},
    { name: 'stormtroopers.jpg', url: 'stormtroopers.jpg'},
    { name: 'kylo_ren.jpg', url: 'kylo_ren.jpg'},
    { name: 'bb2-stroopers.jpg', url: 'bb2-stroopers.jpg'},
    { name: 'lepegetok.jpg', url: 'lepegetok.jpg'},
    { name: 'golden-gate-bridge.jpg', url: 'golden-gate-bridge.jpg'},
    { name: 'caravan.jpg', url: 'caravan.jpg'},
    { name: 'lake.jpg', url: 'lake.jpg'},
    { name: 'mars1.jpg', url: 'mars1.jpg'},
    { name: 'pot.jpg', url: 'pot.jpg'},
    { name: 'putin_and_obama.jpg', url: 'putin_and_obama.jpg'},
    { name: 'reflection.jpg', url: 'reflection.jpg'},
    { name: 'santiago_bernabeu.jpg', url: 'santiago_bernabeu.jpg'},
    { name: 'sunrise.jpg', url: 'sunrise.jpg'},
    { name: 'sunset.jpg', url: 'sunset.jpg'},
    { name: 'waterfall.jpg', url: 'waterfall.jpg'},
    { name: 'zebras.jpg', url: 'zebras.jpg'}
  ];

  fc.backgrounds.path = "/assets/app/backgrounds/";
}(FakeCation));
